export default require('./Icon').default
